import Vue from "vue";
import { SupportedFilePreviewFormats } from "@/lib/utilities/enums";

function initialState() {
  return {
    fileUpload: {
      Files: [],
      UploadsInProgress: 0,
      Total: 0,
      ShowUploadDialog: false,
      MaxSize: 25
    },
    previewFile: null,
    source: {
      Type: "",
      GroupId: ""
    },
    AttachmentMessageModal: {
        ShowModal: false,
        Description: "",
        type: "",
        Buttons: [],
        modalData: null,
        IsDangerous: false
      },
  };
}

const state = initialState();

const getters = {
  fileUpload(state) {
    return state.fileUpload;
  },
  previewFile(state) {
    return state.previewFile;
  },
};

const actions = {
    setAttachmentMessageModal(context, val) {
        context.commit("attachmentMessageModalShowModal", val);
      },
  previewFileUploads(context, val) {
    context.commit("previewFileUploads", val);
  },
  cancelCurrentFileUpload(context) {
    return new Promise((resolve, reject) => {
      context.commit("cancelCurrentFileUpload");
      resolve();
    });
  },
  cancelAllFileUploads(context) {
    context.commit("resetFileUpload");
  },
  removeCurrentFile(context) {
    context.commit("removeCurrentFile");
  },
  decrementTotalUploadFiles(context) {
    context.commit("decrementTotalUploadFiles");
  },
  showFileUploadDialog(context, val) {
    context.commit("showFileUploadDialog", val);
  },
  uploadEmailAttachment(context, data) {
    let formData = new FormData();
    formData.append("file", data);
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/pandox/create_email_attachment", formData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.Data &&
            response.data.Data.length > 0
          ) {
            resolve(response.data.Data[0]);
          } else reject(response);
        })
        .catch(response => {
          reject(response);
        })
        .finally(() => {
          context.commit("removeCurrentFile");
        });
    });
  },
  downloadAttachmentByFileUrl(context, fileUrl) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/chat/message/attachment", {
          params: {
            fileUrl
          },
          responseType: "blob"
        })
        .then(response => {
          if (response) {
            resolve(response);
          } else reject(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  downloadEmailAttachment(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/pandox/get_email_attachment", request, {
          responseType: "blob"
        })
        .then(response => {
          if (response) {
            resolve(response);
          } else reject(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
};

const mutations = {
  attachmentMessageModalShowModal(state, val) {
    state.AttachmentMessageModal.ShowModal = val.ShowModal;
    state.AttachmentMessageModal.Description = val.Description;
    state.AttachmentMessageModal.Buttons = val.Buttons;
    state.AttachmentMessageModal.IsDangerous = val.IsDangerous;

  },
  previewFileUploads(state, val) {
    state.fileUpload.Files = [];
    state.fileUpload.Total = 0;
    state.fileUpload.ShowUploadDialog = false;
    state.fileUpload.MaxSize = 25;

    if (val.Files && val.Files.length > 0) {
      state.fileUpload.Files = [...val.Files];
      state.fileUpload.Total = val.Files.length;
      state.fileUpload.MaxSize = val.MaxSize != undefined ? val.MaxSize : 25

      this.commit("generatePreviewFile", state);
    }
  },
  cancelCurrentFileUpload(state) {
    this.commit("removeCurrentFile");
  },
  resetFileUpload(state) {
    state.fileUpload.Files = [];
    state.fileUpload.Total = 0;
    state.fileUpload.ShowUploadDialog = false;
  },
  updateUploadsInProgress(state, val) {
    state.fileUpload.UploadsInProgress += val;
  },
  decrementTotalUploadFiles(state) {
    state.fileUpload.Total--;
  },
  setPreviewFileData(state, data) {
    state.previewFile.Data = data;
  },
  generatePreviewFile(state) {
    try {
      let previewFile = {
        Name: "",
        IsImage: false,
        Extension: "",
        Data: null,
        Size: 0,
        SizeInKB: 0,
        SizeInBytes: 0,
        File: null,
        Total: state.fileUpload.Files.length,
        MaxSize: state.fileUpload.MaxSize || 25 // 1GB
      };

      let file = state.fileUpload.Files[0];
      let fileName = file.name ? file.name.replace(/ /g, "_") : "";
      let lastIndexOfDot = fileName ? fileName.lastIndexOf(".") : -1;
      let fileExtension =
        lastIndexOfDot >= 0
          ? fileName.substring(lastIndexOfDot + 1).toLowerCase()
          : "";

      previewFile.Name = fileName ? fileName.substring(0, lastIndexOfDot) : "";

      previewFile.Extension = fileExtension;
      previewFile.File = file;

      //Calculate size in diff measurements
      if (file.size && file.size > 0) {
        previewFile.SizeInBytes = file.size;
        previewFile.SizeInKB = (file.size / 1024).toFixed(2) * 1;
        previewFile.Size = (file.size / (1024 * 1024)).toFixed(2) * 1;
      }

      //Check if the file is an image
      //SupportedFilePreviewFormats array has image formats at the beginning
      let extensionIndex = SupportedFilePreviewFormats.indexOf(fileExtension);
      previewFile.IsImage =
        extensionIndex >= 0 &&
        extensionIndex <= SupportedFilePreviewFormats.length - 2;

      state.previewFile = previewFile;

      if (previewFile.IsImage) {
        let reader = new FileReader();
        var vm = this;
        reader.onload = function(e) {
          vm.commit("setPreviewFileData", e.target.result);
        };

        reader.readAsDataURL(file);
      }

      state.fileUpload.ShowUploadDialog = true;
    } catch (err) {
      console.log(err);
      this.commit("removeCurrentFile");
    }
  },
  removeCurrentFile(state) {
    //Current file is always the first file
    state.fileUpload.Files.splice(0, 1);

    if (state.fileUpload.Files && state.fileUpload.Files.length > 0)
      this.commit("generatePreviewFile", state);
    else {
      state.fileUpload.ShowUploadDialog = false;
      state.fileUpload.previewFile = null;
    }
  },
  showFileUploadDialog(state, value) {
    state.fileUpload.ShowUploadDialog = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/FileUpload.js